import { CalendarGrouping } from './types';

const buildCalendarUrl = (
  brandId: string,
  date: string,
  {
    grouping,
    categoryIds,
    vibeIds,
  }: {
    grouping?: CalendarGrouping;
    categoryIds?: ReadonlyArray<string>;
    vibeIds?: ReadonlyArray<string>;
  },
) => {
  const url = new URL(
    `${process.env.KOUTO_API_URL}/v3/brands/${brandId}/calendar/${date}`,
  );
  if (grouping) {
    url.searchParams.set('grouping', grouping);
  }
  if (categoryIds && categoryIds.length > 0) {
    url.searchParams.set('categoryIds', categoryIds.join(','));
  }
  if (vibeIds && vibeIds.length > 0) {
    url.searchParams.set('vibeIds', vibeIds.join(','));
  }
  return url.toString();
};

export default buildCalendarUrl;
